import LayoutConfigTypes from "@/core/config/LayoutConfigTypes";

const isBreadxPay = process.env.VUE_APP_CURRENT_PORTAL === "breadxpay";
const isKatbit = process.env.VUE_APP_THEME === "katbit";
const isFastPAY = process.env.VUE_APP_CURRENT_PORTAL === "fastpay";
const darkLogo = isKatbit
  ? "/media/katbit/logo-dark.png"
  : isFastPAY
  ? "/media/logos/logo-fastpay.png"
  : isBreadxPay
  ? "/media/breadxpay/logo-dark.jpg"
  : "/media/logos/min-logo.png";
const lightLogo = isKatbit
  ? "/media/katbit/logo-light.png"
  : isFastPAY
  ? "/media/logos/logo-fastpay.png"
  : isBreadxPay
  ? "/media/breadxpay/logo-breadx.png"
  : "/media/logos/min-logo.png";

const config: LayoutConfigTypes = {
  themeName: "IBanFlex",
  themeVersion: "8.0.38",
  siteName: (process.env.VUE_APP_CURRENT_PORTAL as string).toUpperCase(),
  demo: process.env.VUE_APP_THEME as string,
  main: {
    type: "default",
    primaryColor: "#234aef",
    background: {
      main: "",
    },
    support_email: "",
    logo: {
      dark: darkLogo,
      light: lightLogo,
    },
  },
  illustrations: {
    set: "unitedpalms-1",
  },
  loader: {
    logo: lightLogo,
    display: true,
    type: "default",
  },
  scrollTop: {
    display: true,
  },
  header: {
    display: true,
    menuIcon: "font",
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  toolbar: {
    display: true,
    width: "fluid",
    fixed: {
      desktop: true,
      tabletAndMobile: true,
    },
  },
  aside: {
    display: true,
    theme: "dark",
    fixed: true,
    menuIcon: "svg",
    minimized: false,
    minimize: true,
    hoverable: true,
  },
  content: {
    width: "fluid",
  },
  footer: {
    width: "fluid",
  },
};

export default config;
